import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { TrendingUp } from "lucide-react";

const PLACEMENTS = [
  { name: "Krishna", role: "ML Engineer", pkg: "$135k", when: "2 days ago" },
  { name: "Dev",     role: "Data Scientist", pkg: "$120k", when: "4 days ago" },
  { name: "Ramani",  role: "AI Engineer", pkg: "$155k", when: "1 week ago" },
  { name: "Sunita",  role: "BI Analyst", pkg: "$95k",  when: "2 weeks ago" },
  { name: "Shreya",  role: "Data Analyst", pkg: "$90k",  when: "3 weeks ago" },
  { name: "Aman",    role: "Cloud Engineer", pkg: "$118k", when: "1 month ago" },
];

export default function PlacementTicker() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % PLACEMENTS.length), 4000);
    return () => clearInterval(id);
  }, []);
  const p = PLACEMENTS[i];
  return (
    <div
      data-testid="placement-ticker"
      className="relative z-10 inline-flex items-center gap-3 px-3 sm:px-4 py-2 rounded-full bg-white/[0.04] border border-white/[0.08] backdrop-blur-md max-w-full overflow-hidden"
    >
      <span className="relative flex h-2 w-2 flex-none">
        <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75" />
        <span className="relative rounded-full h-2 w-2 bg-emerald-400" />
      </span>
      <TrendingUp className="w-3.5 h-3.5 text-emerald-300 flex-none" />
      <div className="text-xs sm:text-sm min-w-0 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.35 }}
            className="whitespace-nowrap text-zinc-300"
          >
            <span className="text-white font-medium">{p.name}</span>
            <span className="text-zinc-500"> · </span>
            <span>{p.role}</span>
            <span className="text-zinc-500"> · </span>
            <span className="text-emerald-300 font-mono">{p.pkg}</span>
            <span className="text-zinc-500 hidden sm:inline"> · placed {p.when}</span>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
